document.addEventListener('DOMContentLoaded', function () {

var org_html = document.querySelector(".product-quantity-wrapper");
var org_html1 = document.querySelector(".quantum-lbw-wishlist-btn")?.parentElement;

if (org_html && org_html1) {
    // Create wrapper div
    var wrapper = document.createElement("div");
    wrapper.id = "qty-wishlist";
    org_html.parentNode.insertBefore(wrapper, org_html);   
    wrapper.appendChild(org_html);
    wrapper.appendChild(org_html1);
}
   
 var flickty_m = document.querySelector('.product-media-slider');
if (flickty_m && !flickty_m.classList.contains('flickity-enabled')) {
    new Flickity(flickty_m, {
        contain: true,
        wrapAround: true,
        resize : true,
        groupCells : true,
        prevNextButtons : false,
        pageDots : true,
        watchCSS: true,
       arrowShape: "M50.1228 1.62718C48.1063 -0.542395 44.8369 -0.542395 42.8204 1.62718L1.51235 46.0716C-0.504121 48.2412 -0.504121 51.7588 1.51235 53.9284L42.8204 98.3728C44.8369 100.542 48.1063 100.542 50.1228 98.3728C52.1392 96.2032 52.1392 92.6857 50.1228 90.5161L17.6293 55.5556H94.8365C97.6882 55.5556 100 53.0682 100 50C100 46.9317 97.6882 44.4444 94.8365 44.4444H17.6293L50.1228 9.48393C52.1392 7.31435 52.1392 3.79676 50.1228 1.62718Z"

    });
   }

 var popupBtn = document.querySelector('.popupbtn');
var closeBtn = document.querySelector('.popup-container .close');

if (popupBtn) {
  popupBtn.addEventListener('click', function (e) {
    e.preventDefault();

    const popup = document.querySelector('.size-char-popup');
    popup.style.display = 'block';
    document.body.classList.add('popupadded');

    // Wait till popup fully visible before initializing Flickity
    setTimeout(() => {
      const flickty_c = document.querySelector('.carousel');
      if (flickty_c) {
        if (flickty_c.classList.contains('flickity-enabled')) {
          // If already initialized, just refresh size
          const flkty = Flickity.data(flickty_c);
          if (flkty) flkty.resize();
        } else {
          // Initialize new Flickity
          new Flickity(flickty_c, {
            contain: true,
            wrapAround: true,
            draggable: false
          });
        }
      }
    }, 100); // delay ensures popup DOM layout is ready
  });
}

if (closeBtn) {
  closeBtn.addEventListener('click', function (e) {
    e.preventDefault();

    const popup = document.querySelector('.size-char-popup');
    const flickty_c = document.querySelector('.carousel');

    // Optional: destroy Flickity to reset next time
    if (flickty_c && flickty_c.classList.contains('flickity-enabled')) {
      const flkty = Flickity.data(flickty_c);
      if (flkty) flkty.destroy();
    }

    popup.style.display = 'none';
    document.body.classList.remove('popupadded');
  });
}


  // Run only on Android / non-iOS touch devices
const isIOS = /iPad|iPod/.test(navigator.userAgent);

document.querySelectorAll('.image-wrapper img').forEach(img => {

    if (isIOS) {
        // ✅ iPhone / iPad ke liye default Safari zoom allow
        img.style.touchAction = 'manipulation'; // ensures normal Safari behavior
        return; // don't apply JS pinch
    }

    // ✅ Android (custom zoom)
    let scale = 1;
    let startDist = 0;
    let startX = 0;
    let startY = 0;
    let translateX = 0;
    let translateY = 0;
    let lastTranslateX = 0;
    let lastTranslateY = 0;

    const container = img.closest('.image_inner');

    img.addEventListener('touchstart', e => {
        if (e.touches.length === 2) {
            startDist = Math.hypot(
                e.touches[0].pageX - e.touches[1].pageX,
                e.touches[0].pageY - e.touches[1].pageY
            );
            startX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
            startY = (e.touches[0].pageY + e.touches[1].pageY) / 2;
        } else if (e.touches.length === 1 && scale > 1) {
            startX = e.touches[0].pageX - lastTranslateX;
            startY = e.touches[0].pageY - lastTranslateY;
        }
    });

    img.addEventListener('touchmove', e => {
        if (e.touches.length === 2) {
            e.preventDefault(); // stop scroll on Android only
            let dist = Math.hypot(
                e.touches[0].pageX - e.touches[1].pageX,
                e.touches[0].pageY - e.touches[1].pageY
            );
            scale = Math.max(1, Math.min(scale * (dist / startDist), 3));

            const midX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
            const midY = (e.touches[0].pageY + e.touches[1].pageY) / 2;
            translateX += (midX - startX) / scale;
            translateY += (midY - startY) / scale;
            startX = midX;
            startY = midY;

            applyBounds();
            img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;

        } else if (e.touches.length === 1 && scale > 1) {
            e.preventDefault();
            translateX = e.touches[0].pageX - startX;
            translateY = e.touches[0].pageY - startY;

            applyBounds();
            img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
        }
    });

    img.addEventListener('touchend', e => {
        lastTranslateX = translateX;
        lastTranslateY = translateY;
    });

    function applyBounds() {
        const rect = container.getBoundingClientRect();
        const imgRect = img.getBoundingClientRect();
        const offsetX = (imgRect.width - rect.width) / 2;
        const offsetY = (imgRect.height - rect.height) / 2;

        translateX = Math.min(offsetX, Math.max(-offsetX, translateX));
        translateY = Math.min(offsetY, Math.max(-offsetY, translateY));
    }
});

  
});


